import React from "react";
import ClientDetailsForm from "./ClientDetailsForm.js";
import CarDetailsForm from "./CarDetailsForm.js";
import ProgramDetailsForm from "./ProgramDetailsForm.js";
import SignContract from "./SignContract.js";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

const tabs = [
    { label: "Данные клиента", icon: <PersonAddIcon /> },
    { label: "Данные автомобиля", icon: <ExitToAppIcon /> },
    { label: "Программа займа", icon: <AccountBoxIcon /> },
    { label: "Печать документов", icon: <AttachMoneyIcon /> }
];

class LoanApproved extends React.Component {

    constructor(props) {
        super();
        const index = ["FIRST", "SECOND", "THIRD", "FOURTH"].indexOf(props.contractStatus);
        this.state = {
            value: index > 0 ? index : 0
        }
    }

    switchTab = (e, value) => this.setState({ value });

    render() {

        const { value } = this.state;

        const { client,
                car,
                onClientDetailsSubmit,
                onCarDetailsSubmit,
                onProgramDetailsSubmit,
                onContractSign } = this.props;

        const { isJuridicalPerson } = client;
        const { _id, number_id, contract } = car;
        const { _id: contractId, clientDetails, carDetails, programDetails } = contract || {};

        return (
            <React.Fragment>
                <Tabs value={value}
                      onChange={this.switchTab}
                      centered >
                    {tabs.map((tab, i) => <Tab key={i}
                                               disabled={value < i}
                                               label={tabs[i].label}
                                               icon={tabs[i].icon} />
                    )}
                </Tabs>
                <SwipeableViews axis="x" index={value}>
                    <div dir="x">
                        {value === 0 &&
                            <ClientDetailsForm client={client}
                                               car_number={number_id}
                                               clientDetails={clientDetails}
                                               onClientDetailsSubmit={onClientDetailsSubmit}
                                               isJur={isJuridicalPerson}
                                               carId={_id}
                                               switchTab={this.switchTab}  />
                        }
                    </div>
                    <div dir="x">
                        {value === 1 &&
                            <CarDetailsForm car={car}
                                            onCarDetailsSubmit={onCarDetailsSubmit}
                                            contractId={contractId}
                                            carDetails={carDetails}
                                            switchTab={this.switchTab} />
                        }
                    </div>
                    <div dir="x">
                        {value === 2 &&
                            <ProgramDetailsForm contractId={contractId}
                                                onProgramDetailsSubmit={onProgramDetailsSubmit}
                                                car={car}
                                                isJur={isJuridicalPerson}
                                                programDetails={programDetails}
                                                switchTab={this.switchTab} />
                        }
                    </div>
                    <div dir="x">
                        {value === 3 &&
                            <SignContract contractId={contractId}
                                          onContractSign={onContractSign}
                                          switchTab={this.switchTab}
                                          isJur={isJuridicalPerson}
                                          programDetails={programDetails}
                                          clientLastname={clientDetails.lastname}
                                          clientFirstname={clientDetails.firstname} />
                        }
                    </div>
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default LoanApproved;



// WEBPACK FOOTER //
// ./src/components/LoanApproved.js